import * as angular from "angular";

angular
  .module('bringoz.admin')
  .config(configMenu);

/* @ngInject */
function configMenu(triMenuProvider) {

  // Orders Menu
  triMenuProvider.addMenu({
    name: 'Orders',
    type: 'dropdown',
    permission: ['oms.orders.list'],
    permissionExcept: ['site.pos'],
    priority: 1,
    children: [
      {
        name: 'Fulfillment Lines',
        type: 'link',
        icon: 'fulfillment',
        state: 'fulfillment-lines',
        permission: 'fulfillment.service.list'
      }
    ]
  });

  // Dispatching Menu
  triMenuProvider.addMenu({
    name: 'Dispatch',
    type: 'dropdown',
    permission: ['services.list', 'market.list', 'point-of-sale.create-delivery', 'coordination.list', 'orders.create', 'orders.delivery.create'],
    priority: 2,
    children: [
      {
        name: 'Services',
        type: 'link',
        icon: 'dispatch',
        state: 'deliveries.table',
        permission: 'services.list',
        permissionExcept: ['site.pos']
      },
      {
        name: 'Services Map',
        type: 'link',
        icon: 'map',
        state: 'deliveries.map',
        permission: 'services.list',
        permissionExcept: ['site.pos']
      },
      {
        name: 'Driver Tracking',
        type: 'link',
        icon: 'agent-tracking',
        state: 'agents-itinerary.list',
        params: {
          status: 'Active'
        },
        permission: 'driver.itinerary.get',
        permissionExcept: ['site.pos']
      },
    ]
  });

  // Planning Menu
  triMenuProvider.addMenu({
    name: 'Planning',
    type: 'dropdown',
    priority: 3,
    permission: ['planning.list', 'planning.create', 'planning.update', 'service-analysis.list'],
    permissionExcept: ['site.pos'],
    children: [
      {
        name: 'Projects',
        type: 'link',
        icon: 'projects',
        state: 'planning.projects.scheduled.calendar',
        permission: 'planning.project.list'
      },
      {
        name: 'Scheduling Project',
        type: 'link',
        icon: 'projects',
        state: 'scheduling-project.visit-plans.table',
        permission: 'schedulingProject.visitPlan.list'
      },
      {
        name: 'Routes',
        type: 'link',
        icon: 'route',
        state: 'planning-routes',
        permission: 'planning.routes.list'
      },
    ]
  });

  // Resources Menu
  triMenuProvider.addMenu({
    name: 'Resources',
    type: 'dropdown',
    priority: 4,
    permission: ['drivers.list', 'accounts.supply.list', 'fleetManagement.vehicles.list', 'planning.shifts.create'],
    permissionExcept: ['site.pos'],
    children: [
      {
        name: 'Carriers',
        type: 'link',
        icon: 'carrier',
        state: 'accounts-list-supply',
        permission: 'accounts.supply.list'
      },
      {
        name: 'Drivers',
        type: 'link',
        icon: 'agent',
        state: 'agents-list',
        permission: 'drivers.list'
      },
      {
        name: 'Allocations',
        type: 'link',
        icon: 'tiles-outline',
        state: 'resources.allocations',
        permission: 'fleetManagement.allocations.list'
      },
    ]
  });

  // Shippers Menu
  triMenuProvider.addMenu({
    name: 'Shippers',
    type: 'dropdown',
    priority: 5,
    permission: ['accounts.demand.list', 'shippers.list', 'customer.list'],
    children: [
      {
        name: 'Accounts',
        type: 'link',
        icon: 'account',
        state: 'accounts-list-demand',
        permission: 'accounts.demand.list',
        permissionExcept: ['site.pos']
      },
      {
        name: 'Agent Assignment Manager',
        type: 'link',
        icon: 'account-group',
        state: 'accounts-agent-assignments',
        permission: 'accounts.preferred.list',
        permissionExcept: ['site.pos']
      },
      {
        name: 'Shippers',
        type: 'link',
        icon: 'shipper',
        state: 'shippers-list',
        permission: 'shippers.list',
        permissionExcept: ['site.pos']
      },
      {
        name: 'Customers',
        type: 'link',
        icon: 'customer',
        state: 'customers',
        permission: 'customer.list'
      },
      {
        name: 'Service Points',
        type: 'link',
        icon: 'map-marker',
        state: 'service-points',
        permission: 'servicePoint.list'
      }
    ]
  });

  // Administration Menu
  triMenuProvider.addMenu({
    name: 'Administration',
    permission: ['serviceAreas.list', 'branches.list', 'depots.list', 'survey.list', 'report.generate.list', 'recurring-service-template.list'],
    permissionExcept: ['site.pos'],
    type: 'dropdown',
    priority: 6,
    children: [
      {
        name: 'Branches',
        type: 'link',
        icon: 'branch',
        state: 'branches',
        permission: 'branches.list'
      },
      {
        name: 'Depots',
        type: 'link',
        icon: 'depot',
        state: 'depots',
        permission: 'depots.list'
      },
      {
        name: 'Sisense Reports',
        type: 'link',
        icon: 'report',
        state: 'sisense',
        permission: 'report.sisense.user'
      },
      {
        name: 'Dashboard',
        type: 'link',
        icon: 'dashboard',
        state: 'dashboards',
        permission: 'dashboard.list'
      },
      {
        name: 'Users Management',
        type: 'link',
        icon: 'contact-circle',
        state: 'policy.users',
        permission: 'iam.policy.get'
      },
      {
        name: 'Reports',
        type: 'link',
        icon: 'report',
        state: 'reports.deliveries.site-deliveries',
        permission: 'report.generate.list'
      },
      {
        name: 'Timecards',
        type: 'link',
        icon: 'timer-outline',
        state: 'timekeeping',
        permission: 'timekeeping.timeCard.list'
      },
      // {
      //   name: 'Settings',
      //   icon: 'settings',
      //   type: 'dropdown',
      //   permission: ['iam.policy.get'],
      //   children: [
      //     {
      //       name: 'Admin Users',
      //       type: 'link',
      //       icon: 'contact-circle',
      //       state: 'policy.users',
      //       permission: 'iam.policy.get'
      //     },
      //   ]
      // }
    ]
  });
}
